/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { DigitaloceanVolumesListRsp } from '../models/digitalocean-volumes-list-rsp';
import { DigitaloceanVolumesCreateRsp } from '../models/digitalocean-volumes-create-rsp';
import { DigitaloceanVolumesCreateReq } from '../models/digitalocean-volumes-create-req';
import { DigitaloceanVolumesLookupRsp } from '../models/digitalocean-volumes-lookup-rsp';
import { DigitaloceanVolumesDeleteRsp } from '../models/digitalocean-volumes-delete-rsp';
import { DigitaloceanVolumesInfoRsp } from '../models/digitalocean-volumes-info-rsp';
import { RuntimeStreamError } from '../models/runtime-stream-error';
import { DigitaloceanVolumesExportRsp } from '../models/digitalocean-volumes-export-rsp';
@Injectable({
  providedIn: 'root',
})
class VolumesServiceService extends __BaseService {
  static readonly VolumesListPath = '/api/digitalocean/v2/volumes';
  static readonly VolumesCreatePath = '/api/digitalocean/v2/volumes';
  static readonly VolumesLookupPath = '/api/digitalocean/v2/volumes/{volume_id}';
  static readonly VolumesDeletePath = '/api/digitalocean/v2/volumes/{volume_id}';
  static readonly VolumesInfoPath = '/api/digitalocean/v2/volumes/{volume_id}/info';
  static readonly VolumesExportPath = '/api/digitalocean/v2/volumes/{volume}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `VolumesServiceService.VolumesListParams` containing the following parameters:
   *
   * - `region`: region slug.
   *
   * - `per_page`:
   *
   * - `page`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  VolumesListResponse(params: VolumesServiceService.VolumesListParams): __Observable<__StrictHttpResponse<DigitaloceanVolumesListRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.region != null) __params = __params.set('region', params.region.toString());
    if (params.perPage != null) __params = __params.set('per_page', params.perPage.toString());
    if (params.page != null) __params = __params.set('page', params.page.toString());
    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/digitalocean/v2/volumes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanVolumesListRsp>;
      })
    );
  }
  /**
   * @param params The `VolumesServiceService.VolumesListParams` containing the following parameters:
   *
   * - `region`: region slug.
   *
   * - `per_page`:
   *
   * - `page`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  VolumesList(params: VolumesServiceService.VolumesListParams): __Observable<DigitaloceanVolumesListRsp> {
    return this.VolumesListResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanVolumesListRsp)
    );
  }

  /**
   * @param body undefined
   * @return A successful response.
   */
  VolumesCreateResponse(body: DigitaloceanVolumesCreateReq): __Observable<__StrictHttpResponse<DigitaloceanVolumesCreateRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = body;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/digitalocean/v2/volumes`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanVolumesCreateRsp>;
      })
    );
  }
  /**
   * @param body undefined
   * @return A successful response.
   */
  VolumesCreate(body: DigitaloceanVolumesCreateReq): __Observable<DigitaloceanVolumesCreateRsp> {
    return this.VolumesCreateResponse(body).pipe(
      __map(_r => _r.body as DigitaloceanVolumesCreateRsp)
    );
  }

  /**
   * @param params The `VolumesServiceService.VolumesLookupParams` containing the following parameters:
   *
   * - `volume_id`:
   *
   * - `region`:
   *
   * - `name`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  VolumesLookupResponse(params: VolumesServiceService.VolumesLookupParams): __Observable<__StrictHttpResponse<DigitaloceanVolumesLookupRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.region != null) __params = __params.set('region', params.region.toString());
    if (params.name != null) __params = __params.set('name', params.name.toString());
    (params.fields || []).forEach(val => {if (val != null) __params = __params.append('fields', val.toString())});
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/digitalocean/v2/volumes/${params.volumeId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanVolumesLookupRsp>;
      })
    );
  }
  /**
   * @param params The `VolumesServiceService.VolumesLookupParams` containing the following parameters:
   *
   * - `volume_id`:
   *
   * - `region`:
   *
   * - `name`:
   *
   * - `fields`:
   *
   * @return A successful response.
   */
  VolumesLookup(params: VolumesServiceService.VolumesLookupParams): __Observable<DigitaloceanVolumesLookupRsp> {
    return this.VolumesLookupResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanVolumesLookupRsp)
    );
  }

  /**
   * @param params The `VolumesServiceService.VolumesDeleteParams` containing the following parameters:
   *
   * - `volume_id`:
   *
   * - `region`:
   *
   * - `name`:
   *
   * @return A successful response.
   */
  VolumesDeleteResponse(params: VolumesServiceService.VolumesDeleteParams): __Observable<__StrictHttpResponse<DigitaloceanVolumesDeleteRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.region != null) __params = __params.set('region', params.region.toString());
    if (params.name != null) __params = __params.set('name', params.name.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/digitalocean/v2/volumes/${params.volumeId}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanVolumesDeleteRsp>;
      })
    );
  }
  /**
   * @param params The `VolumesServiceService.VolumesDeleteParams` containing the following parameters:
   *
   * - `volume_id`:
   *
   * - `region`:
   *
   * - `name`:
   *
   * @return A successful response.
   */
  VolumesDelete(params: VolumesServiceService.VolumesDeleteParams): __Observable<DigitaloceanVolumesDeleteRsp> {
    return this.VolumesDeleteResponse(params).pipe(
      __map(_r => _r.body as DigitaloceanVolumesDeleteRsp)
    );
  }

  /**
   * @param volume_id undefined
   * @return A successful response.
   */
  VolumesInfoResponse(volumeId: string): __Observable<__StrictHttpResponse<DigitaloceanVolumesInfoRsp>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/digitalocean/v2/volumes/${volumeId}/info`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<DigitaloceanVolumesInfoRsp>;
      })
    );
  }
  /**
   * @param volume_id undefined
   * @return A successful response.
   */
  VolumesInfo(volumeId: string): __Observable<DigitaloceanVolumesInfoRsp> {
    return this.VolumesInfoResponse(volumeId).pipe(
      __map(_r => _r.body as DigitaloceanVolumesInfoRsp)
    );
  }

  /**
   * @param params The `VolumesServiceService.VolumesExportParams` containing the following parameters:
   *
   * - `volume`:
   *
   * - `account`:
   *
   * @return A successful response.(streaming responses)
   */
  VolumesExportResponse(params: VolumesServiceService.VolumesExportParams): __Observable<__StrictHttpResponse<{error?: RuntimeStreamError, result?: DigitaloceanVolumesExportRsp}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.account != null) __params = __params.set('account', params.account.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/digitalocean/v2/volumes/${params.volume}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{error?: RuntimeStreamError, result?: DigitaloceanVolumesExportRsp}>;
      })
    );
  }
  /**
   * @param params The `VolumesServiceService.VolumesExportParams` containing the following parameters:
   *
   * - `volume`:
   *
   * - `account`:
   *
   * @return A successful response.(streaming responses)
   */
  VolumesExport(params: VolumesServiceService.VolumesExportParams): __Observable<{error?: RuntimeStreamError, result?: DigitaloceanVolumesExportRsp}> {
    return this.VolumesExportResponse(params).pipe(
      __map(_r => _r.body as {error?: RuntimeStreamError, result?: DigitaloceanVolumesExportRsp})
    );
  }
}

module VolumesServiceService {

  /**
   * Parameters for VolumesList
   */
  export interface VolumesListParams {

    /**
     * region slug.
     */
    region?: string;
    perPage?: string;
    page?: string;
    fields?: Array<'field_all' | 'field_id' | 'field_name' | 'field_region' | 'field_droplet_ids' | 'field_description' | 'field_size_gigabytes' | 'field_created_at' | 'field_filesystem_type' | 'field_filesystem_label' | 'field_tags'>;
  }

  /**
   * Parameters for VolumesLookup
   */
  export interface VolumesLookupParams {
    volumeId: string;
    region?: string;
    name?: string;
    fields?: Array<'field_all' | 'field_id' | 'field_name' | 'field_region' | 'field_droplet_ids' | 'field_description' | 'field_size_gigabytes' | 'field_created_at' | 'field_filesystem_type' | 'field_filesystem_label' | 'field_tags'>;
  }

  /**
   * Parameters for VolumesDelete
   */
  export interface VolumesDeleteParams {
    volumeId: string;
    region?: string;
    name?: string;
  }

  /**
   * Parameters for VolumesExport
   */
  export interface VolumesExportParams {
    volume: string;
    account?: string;
  }
}

export { VolumesServiceService }
